<template>
  <div class="container">
    <div class="tips">
      <div class="tips__oops">抱歉!</div>
      <div class="tips__headline">页面不存在 或者 无权访问</div>
      <div class="tips__info">请核对访问网址 或者 点击下方按钮返回首页</div>
      <van-button class="mr-10" type="warning" icon="arrow-left" @click="$router.go(-1)">后退</van-button>
      <van-button type="primary" icon="wap-home-o" @click="$router.replace('/')">回到首页</van-button>
    </div>
  </div>
</template>

<script>
import { Button } from 'vant';
export default {
  name: "Page404",
  components: { [Button.name]: Button }
};
</script>

<style lang="less" scoped>
.container {
  transform: translate(-50%, -50%);
  position: absolute;
  top: 40%;
  left: 50%;
  width: 90%;

  .tips {
    line-height: 1.7;
  }
}
</style>
